import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const CardsListItem = styled.li`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 260px;
  height: 355px;
  border: 1px solid ${COLORS.line};
  border-radius: 4px;
  background-color: ${COLORS.background};
  overflow: hidden;
  cursor: pointer;
  transition: background-color 0.3s ease-out;

  &:hover {
    background-color: ${COLORS.line};
  }
`;

export default CardsListItem;
